export const SekansPadsRow = props => {
  const edition = props.edition

  const activeBtnsArr = props.activeBtns
  const padsIndexes = props.padsIndexes

  const activePads = activeBtnsArr.map(item => {
    if (item) return true
    return false
  })

  const activeCursorArr = props.activeCursor

  const activeCursorOnPads = activeCursorArr.map(item => {
    if (item) return true
    return false
  })

  const justCleared = props.justCleared

  const padClassNameArr = []

  for (let i = 0; i < activePads.length; i++) {
    padClassNameArr.push("sekansPad noContextMenu pointerHover")
  }

  for (let i = 0; i < activePads.length; i++) {
    if (justCleared[i]) padClassNameArr[i] += " justCleared"
    else {
      switch(edition) {
        case "prototype":
          if (activePads[i] && activeCursorOnPads[i]) padClassNameArr[i] += " activeWithCursorSekansPrototype"
          else if (activePads[i] && !activeCursorOnPads[i]) padClassNameArr[i] += " activeWithoutCursorSekansPrototype"
          else if (!activePads[i] && activeCursorOnPads[i]) padClassNameArr[i] += " inactiveWithCursorSekansPrototype"
          else padClassNameArr[i] += " inactiveWithoutCursorSekansPrototype"
          break

        case "glacier":
          if (activePads[i] && activeCursorOnPads[i]) padClassNameArr[i] += " activeWithCursorSekansGlacier"
          else if (activePads[i] && !activeCursorOnPads[i]) padClassNameArr[i] += " activeWithoutCursorSekansGlacier"
          else if (!activePads[i] && activeCursorOnPads[i]) padClassNameArr[i] += " inactiveWithCursorSekansGlacier"
          else padClassNameArr[i] += " inactiveWithoutCursorSekansGlacier"
          break

        case "acid":
          if (activePads[i] && activeCursorOnPads[i]) padClassNameArr[i] += " activeWithCursorSekansAcid"
          else if (activePads[i] && !activeCursorOnPads[i]) padClassNameArr[i] += " activeWithoutCursorSekansAcid"
          else if (!activePads[i] && activeCursorOnPads[i]) padClassNameArr[i] += " inactiveWithCursorSekansAcid"
          else padClassNameArr[i] += " inactiveWithoutCursorSekansAcid"
          break

        case "volcano":
          if (activePads[i] && activeCursorOnPads[i]) padClassNameArr[i] += " activeWithCursorSekansVolcano"
          else if (activePads[i] && !activeCursorOnPads[i]) padClassNameArr[i] += " activeWithoutCursorSekansVolcano"
          else if (!activePads[i] && activeCursorOnPads[i]) padClassNameArr[i] += " inactiveWithCursorSekansVolcano"
          else padClassNameArr[i] += " inactiveWithoutCursorSekansVolcano"
          break

        case "royale":
          if (activePads[i] && activeCursorOnPads[i]) padClassNameArr[i] += " activeWithCursorSekansRoyale"
          else if (activePads[i] && !activeCursorOnPads[i]) padClassNameArr[i] += " activeWithoutCursorSekansRoyale"
          else if (!activePads[i] && activeCursorOnPads[i]) padClassNameArr[i] += " inactiveWithCursorSekansRoyale"
          else padClassNameArr[i] += " inactiveWithoutCursorSekansRoyale"
          break

        default: break
      }
    }
  }

  // for (let i = 0; i < activePads.length; i++) {
  //   if (justCleared[i]) padClassNameArr.push("sekansPad justCleared noContextMenu pointerHover")
  //   else if (activePads[i] && activeCursorOnPads[i]) padClassNameArr.push("sekansPad activeWithCursor noContextMenu pointerHover")
  //   else if (activePads[i] && !activeCursorOnPads[i]) padClassNameArr.push("sekansPad activeWithoutCursor noContextMenu pointerHover")
  //   else if (!activePads[i] && activeCursorOnPads[i]) padClassNameArr.push("sekansPad inactiveWithCursor noContextMenu pointerHover")
  //   else padClassNameArr.push("sekansPad inactiveWithoutCursor noContextMenu pointerHover")
  // }

  const stepsArr = []

  for (let i = 1; i <= props.stepsAmount; i++) {
    stepsArr.push(i)
  }

  return (
      <div className="sekansRowContainer"> 
          {stepsArr.map((step, index) => {
            return (
              <div type="button" className={padClassNameArr[index]} data-row={padsIndexes[index].row} data-col={padsIndexes[index].col} data-action="togglePadStatus" key={step} onGotPointerCapture={props.handlePointer} onClick={props.handleClick} onDragEnter={props.handleDragEnter} />
            )
          })}
      </div>
  )
}